import React, { useEffect, useState } from "react";
import {
  
  Typography,
  Checkbox,
  FormControlLabel,
  Box,
  Paper,
  Button,
  Grid,
  CircularProgress
} from "@material-ui/core";
import { Container } from "react-bootstrap";
import { getPaymentPreferences, getPaymentPreferencesList, savePaymentPreferences } from "../../store/actions/userOnboarding";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { isSameArray } from "../../config/utils";

const PaymentSetup = (props) => {
  const {isViewUserRequest, data, activeStep, handleBack, handleNext} = props;
  const [paymentPrefs, setPaymentPrefs] = useState([]);
  const [loader, setLoader] = useState(false);
  const [savedPrefs, setSavedPrefs] = useState([]);
  const defaultPreference = 6; // Assuming 6 is the default preference ID to be selected for new users
  useEffect(() => {
    getPreferencesList();
  }, []);

  const getPreferencesList = async () => {
    setLoader(true);
    let paymentRes = await getPaymentPreferencesList();
    if (paymentRes?.data) {
      let prefs = paymentRes.data.EntityList.map(item => ({
        ...item,
        isChecked: false
      }));
      setPaymentPrefs(prefs);
      getPreferences();
    }
  };

  const getPreferences = async () => {
    let paymentRes = await getPaymentPreferences(isViewUserRequest ? data.Id : null);
    if (paymentRes?.data?.Status === 200) {
      setSavedPrefs(paymentRes.data.Entity.paymentModeIds);
      let savedData = paymentRes.data.Entity.paymentModeIds;
      setPaymentPrefs(prev => prev.map(item => ({ ...item, isChecked: savedData.includes(item.id) })));
    } else {
      setPaymentPrefs(prev => prev.map(item => ({ ...item, isChecked: item.id === defaultPreference })));
    }
    setLoader(false);
  };

  const saveForm = async () => {
    let selectedPrefs = paymentPrefs.filter(item => item.isChecked).map(item => item.id);

    if (isSameArray(selectedPrefs, savedPrefs)) {
      handleNext();
      return;
    }
    if (selectedPrefs.length === 0) {
      toast.error("Please select at least one payment preference.");
      return;
    }
    let payloadata = {
      paymentModeIds: selectedPrefs,
      onboardingId: isViewUserRequest ? data.Id : 0,
    }
    setLoader(true);
    let res = await savePaymentPreferences(payloadata);
    if (res?.data?.Status === 200) {
      toast.success("Payment preferences saved successfully.");
      setLoader(false);
      handleNext();
    } else {
      toast.error("Failed to save payment preferences. Please try again.");
      setLoader(false);
    }
  };

  const handleChange = (event, modeCode) => {
    const { checked } = event.target;
    setPaymentPrefs(prev => prev.map(item => item.modeCode === modeCode ? { ...item, isChecked: checked } : item));
  };

  return (
    <Container fluid>
      <Paper className='onboardingFormWrapping fw-3' elevation={2} square>
        <Typography variant="h6">Select Payment Preference</Typography>
        {loader && (<div className="full-screen-spinner-overlay"><CircularProgress disableShrink /></div>)}
        <Box mt={4}>
            <Grid container spacing={2}>
                {paymentPrefs.map((item, index) => (
                  <Grid item xs={6} md={4} lg={3} key={item.id}>
                      <FormControlLabel
                        control={
                          <Checkbox
                              name={item.modeCode}
                              checked={item.isChecked}
                              onChange={(event) => handleChange(event, item.modeCode)}
                              style={{ color: "#1b76af" }}
                          />
                        }
                        label={item.modeName}
                      />
                  </Grid>
                ))}
            </Grid>
        </Box>
      </Paper>
      <div className='flexPayment mt-2'>
        {!isViewUserRequest ? <Typography component="em">* Please complete the form to finalize your onboarding process</Typography> : <Typography component="em"></Typography>}
        <div className="mt-3 alignItemsCenter">
          <Button disabled={activeStep === 0} onClick={handleBack} disableElevation>
              Back
          </Button>
          <Button
              disableElevation
              variant="contained"
              color="primary"
              onClick={saveForm}
              className='ml-2 cus-seconday-bg-btn btn'
          >
              Save & Next
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default PaymentSetup;

PaymentSetup.propTypes = {
    isViewUserRequest: PropTypes.bool,
    data: PropTypes.object,
    activeStep: PropTypes.number,
    handleBack: PropTypes.func,
    handleNext: PropTypes.func,
}